import React from 'react';
import styled from 'styled-components';
import {SideMenuProps} from './types';
import {SideMenuHeader} from './SideMenuHeader';
import {SideMenuFooter} from './SideMenuFooter';
import {SideMenuBody} from './SideMenuBody';
import {BOXSHADOWS, COLORS, Z_INDEXES} from '../styles';
import {Size} from '../types';

const Wrapper = styled.div`
  z-index: ${Z_INDEXES.off_canvas};
  height: 100%;
  box-sizing: border-box;
  background: ${props => COLORS.getColor('white', props.theme)};

  display: flex;
  flex-direction: column;

  width: fit-content;
  box-shadow: ${BOXSHADOWS.BOXSHADOW_CENTERED};

  &.small {
    min-width: 320px;
  }

  &.medium {
    min-width: 400px;
  }

  &.large {
    min-width: 480px;
  }
`;


const SideMenu: React.FunctionComponent<SideMenuProps> = (props) => {
  const {size = Size.Medium, className, ...rest} = props;

  return (
    <Wrapper className={`${size} ${className || ''}`} {...rest}>
      <SideMenuHeader {...props} />
      <SideMenuBody {...props}/>
      {props.footer && <SideMenuFooter {...props}/>}
    </Wrapper>
  );
}

export default SideMenu;
